module.exports = __webpack_public_path__ + "static/media/pl.1f9d98ad.svg";